import React from 'react';
import { LinearProgress, Stack } from '@mui/material';

import Contract_Header_Info from '../Contract_Header_Info/Contract_Header_Info';
import Details_Operations from '../Details_Operations/Details_Operations';
import Receiptions from '../Receiptions/Receiptions';
import { useState } from 'react';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const Details_Header = ({ details, noAction }) => {
  const [receiptions, setReceptions] = useState([]);
  return (
    <React.Fragment>
      <Stack
        bgcolor={`${themeColors.ColorSecondary} !important`}
        gap=".5em"
        p=".5em"
        borderRadius={'20px'}
      >
        <Contract_Header_Info
          details={details}
          setReceptions={setReceptions}
        />
        {noAction ? (
          <></>
        ) : (
          <Details_Operations
            details={details}
            setReceptions={setReceptions}
          />
        )}

        {receiptions === 0 ? (
          <LinearProgress />
        ) : receiptions?.length > 0 ? (
          <Receiptions
            receiptions={receiptions}
            setReceptions={setReceptions}
            details={details}
          />
        ) : (
          <></>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default Details_Header;
